export function fmtEurCompact(value) {
  const amount = Number(value) || 0;
  const hasCents = Math.round(amount * 100) % 100 !== 0;

  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);
}
